var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.149 7.34L8.707 8.78V1.724H7.373V8.78L5.931 7.339l-.942.943 3.051 3.051 3.051-3.051-.942-.943zM2 12.666A1.333 1.333 0 003.333 14h9.334A1.334 1.334 0 0014 12.667V9.333h-1.333v3.334H3.333V9.333H2v3.334z",
    fill: "#121314"
  })));
}
export default SvgMedium;